// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","footnotes":"_23zF9","footnote":"_3ckvm"};